import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			// loader-chair-tai-chi-m
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Chair Tai Chi for Glucose Reduction Based on Your Age',
					size: 'small',
				}),
			},
		},
		{
			// age-chair-tai-chi-m — LandingTitleExtended auto-uppercases the title; keep the note
			components: {
				LandingTitleExtended: ({ $t }): LandingComponentsConfig['LandingTitleExtended'] => ({
					title: 'Chair Tai Chi for Glucose Reduction',
					note: $t('female_yoga.pages.landing.quiz'),
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
